import $ from 'jquery';

$(function() {
    var $zipInput = $('#postalCode');
    var $select1 = $('#serviceCategory');
    var $select2 = $('#service');
  
    function checkInputs() {
      var zip = $zipInput.val();
      var serviceTypes = $select1.val();
      var services = $select2.val();
  
      if (zip !== '' && zip.length === 5 && serviceTypes !== '' && services !== '') {
        var $exampleModal = $('#bidBoxModal');
        if ($exampleModal.length) {
          $exampleModal.foundation('open');
        }
      }
    }
  
    $zipInput.on('input', checkInputs);
    $select1.on('change', checkInputs);
    $select2.on('change', checkInputs);
  });

  
$('#bid-box-form').submit(function (event) {
    event.preventDefault();
    var $zipInput = $('#postalCode');
    var $select1 = $('#serviceCategory');
    var $select2 = $('#service');
    
    var zip = $zipInput.val();
    var serviceType = $select1.val();
    var service = $select2.val();

    const name = $('#name').val();
    const email = $('#email').val();
    const phone = $('#phone').val();
    const description = $('#description').val();
  
    let data = {
        zip,
        serviceType,
        service,
        name,
        email,
        phone,
        description,
      };
      data[window.csrfTokenName] = window.csrfTokenValue;
      $.ajax({
        url: window.bidBoxAction,
        method: 'POST',
        data: data,
        success: function(response) {
            if (response.success) {
                $('#bid-box-response').html(response.message);
                $('#bid-box-response').removeClass('error').removeClass('hidden');
            } else {
                $('#bid-box-response').html(response.message);
                $('#bid-box-response').addClass('error').removeClass('hidden');
            }
        },
        error: function(response) {
          console.log('There was an error');
          console.log(response);
          let message = "There was an error";
          if (response && response.message) {
            message = response.message;
          }
          $('#bid-box-response').html(message);
          $('#bid-box-response').removeClass('success').addClass('error');
        }
      });
  });
  